import {connect} from 'react-redux'
import classnames from 'classnames'
import {Link} from 'react-router'
import PropTypes from 'prop-types'

import CompleteFirmSetup from '../firm_admin/CompleteFirmSetup'
import EditFirm from './EditFirm'
import {findRawResourceById} from '../../../../lib/plan_data/userData'

import './firmHeader.scss'


export const FirmHeader = props => (
  <div
    className={classnames(
      'firm-header',
      props.className,
      `${props.flowType}-wrapper`,
      {'no-border-bottom': props.firmType === 'funeral_home'}
    )}>
    {
      props.isAccountManager &&
      props.flavor === 'firmUser' &&
        <Link className='back-to-firm-users' to={`/pro/firm/${props.firmId}/users`}>&laquo;  Back to Firm Users</Link>
    }
    <div className='header-contents row-wrapper'>
      <h1>{props.headerText}</h1>
      {props.isAccountManager && !props.isMigrated && <span className='firm-attribute'>&nbsp;Legacy</span>}
      {props.internal && <span className='firm-attribute'>&nbsp;Internal</span>}
      {props.isAccountManager && props.pendingSetup && <span className='firm-attribute'>&nbsp;Pending Setup</span>}
      {
        props.isAccountManager &&
        props.flavor === 'firm' &&
          <EditFirm firmName={props.headerText} {...props} />
      }
    </div>
    {
      props.isAccountManager &&
      props.flavor === 'firm' &&
      props.pendingSetup && (
        <div className='pending-setup-banner'>
          <p className='note'>
            This firm was created automatically from a Sales Studio order and is awaiting setup.
            Client invitations are being held until setup is marked as complete.
          </p>
          <CompleteFirmSetup firmId={props.firmId} firmName={props.headerText} />
        </div>
      )
    }
    {props.children}
  </div>
)


const mapStateToProps = (state, ownProps) => {
  const firm = findRawResourceById({
    rawResource: state.api.firms,
    id: ownProps.firmId
  })

  return {
    isMigrated: firm.get('migrated-at'),
    // Pages backed by the legacy firm store pass pendingSetup explicitly (see
    // firmHeaderPropsHelper); fall back to the redux firm for pages that don't.
    pendingSetup: ownProps.pendingSetup === undefined ? Boolean(firm.get('pending-setup')) : ownProps.pendingSetup
  }
}

FirmHeader.defaultProps = {
  className: null,
  children: null,
  flowType: 'column',
  headerText: '',
  flavor: 'firm',
  isMigrated: null
}

FirmHeader.propTypes = {
  firmId: PropTypes.string,
  firmType: PropTypes.string,
  flavor: PropTypes.string,
  flowType: PropTypes.oneOf(['column', 'row']),
  headerText: PropTypes.string,
  isAccountManager: PropTypes.bool,
  internal: PropTypes.bool,
  isMigrated: PropTypes.string,
  pendingSetup: PropTypes.bool
}

export default connect(mapStateToProps)(FirmHeader)
